import axios from '../../../../api/axios';
import React,{useState,useEffect} from 'react'
import Formulaire from '../../../ModelesPages/Modele1/FormulaireSection'
import Swal from 'sweetalert2';
import {useParams,useNavigate} from 'react-router-dom'

function Insertion(){

    const [Count,setCount]=useState(0);

    const [nom,setNom]=useState("");
    const [litterature,setLitterature]=useState("")
    const {id}=useParams()
    const navigate=useNavigate()
    const csrf=()=>axios.get('sanctum/csrf-cookie')
    useEffect(()=>{
        HanleRequest()
    },[])
    function handleMouse(e){

        e.target.textContent="Bonjour"
    }
    function handleMouseleave(e){
        e.target.textContent="Soumettre"
    }
    function handlekeyUpgain(e){
    
        const elementss=e.nextElementSibling;
      
    }
    function handleclick(){
        alert('You have clicked me')
    }
    const HanleRequest=async(e)=>{
        await axios.get(`/api/Section/${id}`).then((res)=>{
            setNom(res.data.items.nom)
            setLitterature(res.data.items.litterature)
            console.log(res)
        }).catch((err)=>{
            console.log(err)
        })
    }
    function confirmSave(e){
        e.preventDefault()
        if(nom !="" && litterature!=""){
        Swal.fire({
            title:'Demande de confirmation',
            text:'Voulez-vous vraiment mettre à jour cette section ?',
            icon:'question',
            showCancelButton:true,
            showConfirmButton:true,
            confirmButtonText:'Confirmer',
        }).then((resultat)=>{
            if(resultat.isConfirmed){
                HandleSubmit()
            }
        })  
        }
        else{
            Swal.fire({
                title:'Erreur de soumission',
                text:'Veuillez d\'abord confirmer le nom de la section',
                icon:'warning'
            })
        }
    }
    const HandleSubmit=async (e)=>{
                await axios.put(`/api/Section/${id}`,{nom:nom.toLowerCase(),litterature:litterature.toLowerCase()}).then((res)=>{
                    setNom("")
                    setLitterature("")
                    if(res.data.status_code===200){
                        Swal.fire({
                            title:'Message de confirmation',
                            text:'La section a été mise à jour avec succès',
                            icon:'success'
                            
                        }).then((resultat)=>{
                            navigate('/section')
                        })
                    }
                     
                }).catch((err)=>{

                })
    }
    return(
    <>
    <Formulaire title="Formulaire d'inscription" onclick={handleclick} litterature={litterature} setLitterature={setLitterature} confirmSave={confirmSave} setNom={setNom} handlekeyUpgain={handlekeyUpgain}  nom={nom}  handleMouse={handleMouse} Count={Count} setCount={setCount} handleMouseleave={handleMouseleave} HandleSubmit={HandleSubmit}  >
    <div className="w-full md:w-1/1 px-3  md:mb-0">
       
    <div id="resultat" className="block text-red-700"></div>
    <div id="erreur" className="block text-red-500"></div>
    </div>
    </Formulaire>
    </>
    )
}
export default Insertion